module.exports = __webpack_public_path__ + "static/media/GeojiCoinShapeRed.47c42ad6.svg";